/**
 * CAPE BYRON Excel workbook ↔ Atlas MGA mapping (parity checklist).
 * Reference: files/CAPE BYRON draft MGA MAY 2026..xls
 */

export type ParityStatus = 'ok' | 'partial' | 'out';

export type ParityItem = {
  excelSheet: string;
  atlas: string;
  status: ParityStatus;
  note: string;
  /** Optional live metric label shown beside the row */
  metricKey?:
    | 'gross'
    | 'net'
    | 'ot'
    | 'cashBal'
    | 'ctm'
    | 'bondedBal'
    | 'cashByMaster'
    | 'allotments'
    | 'payslips';
};

export const MGA_EXCEL_PARITY: ParityItem[] = [
  {
    excelSheet: 'PAYROLL',
    atlas: 'Sheet → Payroll',
    status: 'ok',
    note: 'Crew wages, OT hrs/rate/total, previous balance, structured deductions, footers',
    metricKey: 'net',
  },
  {
    excelSheet: 'PAYROLL · OT',
    atlas: 'OT Hrs / Rate / Total',
    status: 'ok',
    note: 'Extra OT beyond fixed contract OT columns',
    metricKey: 'ot',
  },
  {
    excelSheet: 'CASH',
    atlas: 'Sheet → Cash / CTM',
    status: 'ok',
    note: 'Income + crew cash advances (expenses linked to crew → Master adv.)',
    metricKey: 'cashBal',
  },
  {
    excelSheet: 'CTM',
    atlas: 'Cash entries type CTM',
    status: 'ok',
    note: 'Cash-to-Master remittances live in the cash book (not a separate tab)',
    metricKey: 'ctm',
  },
  {
    excelSheet: 'BONDED STORE',
    atlas: 'Sheet → Bonded',
    status: 'ok',
    note: 'STOCK / INCOMING / EXPENSE; month-end remaining stock for import',
    metricKey: 'bondedBal',
  },
  {
    excelSheet: 'CREW REQUESTED',
    atlas: 'Sheet → Crew requests',
    status: 'ok',
    note: 'Cash by master → Master adv.; Allotments → ALLOT',
    metricKey: 'cashByMaster',
  },
  {
    excelSheet: 'Per-crew sheets',
    atlas: 'Payslip print',
    status: 'ok',
    note: 'Browser print A4 (MASTER / CH.OFF … style monthly pay account)',
    metricKey: 'payslips',
  },
  {
    excelSheet: 'MAIN',
    atlas: '—',
    status: 'out',
    note: 'Port call / voyage days — not in MGA v1',
  },
  {
    excelSheet: 'Multi-currency EUR+USD',
    atlas: 'Cash FX rate → period amount',
    status: 'ok',
    note: 'Cash lines store currency + exchangeRate; books and Master adv. use amountPeriod',
  },
];

export function parityBadgeLabel(status: ParityStatus) {
  if (status === 'ok') return 'Matched';
  if (status === 'partial') return 'Partial';
  return 'Not in scope';
}
